import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const MagazineCreateModal = ({ 
  isOpen, 
  toggleModal, 
  newMagazine, 
  handleInputChange, 
  handleCreateMagazine,
  isCreating = false
}) => {
  return (
    <>
      <ModalHeader className="bg-primary text-white">
        Create New Magazine
      </ModalHeader>
      <ModalBody>
        <div className="p-4">
          <form onSubmit={handleCreateMagazine}>
            <div className="mb-4">
              <label className="form-label fw-bold">
                PDF Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="pdfName"
                className="form-control form-control-lg"
                placeholder="Enter PDF name"
                value={newMagazine.pdfName}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-4">
              <label className="form-label fw-bold">
                PDF File <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type="file"
                  name="file"
                  className="form-control"
                  accept="application/pdf"
                  onChange={handleInputChange}
                  required
                />
              </div>
              <small className="text-muted">
                Only PDF files are accepted
              </small>
            </div>
            <div className="text-end">
              <Button
                color="secondary"
                className="me-2"
                onClick={toggleModal}
              >
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={isCreating}>
                {isCreating ? "Creating..." : "Create Magazine"}
              </Button>
            </div>
          </form>
        </div>
      </ModalBody>
    </>
  );
};

export default MagazineCreateModal; 